var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-pop-select-input" },
    [
      _c("el-input", {
        attrs: { value: _vm.displayName ? _vm.displayName : _vm.eventName },
        nativeOn: {
          click: function($event) {
            _vm.dialogVisible = true
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "1160px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", margin: "10px" } },
            [
              _c(
                "span",
                {
                  staticStyle: { "align-self": "center", "margin-right": "5px" }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")) + ": ")]
              ),
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { placeholder: _vm.$t("SeaExport.PleaseInputAKeyword") },
                on: {
                  input: function($event) {
                    _vm.selectedBak = _vm.displayName
                  }
                },
                model: {
                  value: _vm.searchValue,
                  callback: function($$v) {
                    _vm.searchValue = $$v
                  },
                  expression: "searchValue"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "grid" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { height: "100%", "min-height": "400px" },
                attrs: {
                  "column-defs": _vm.columnDefs,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.filterData,
                  "show-side-bar": false
                }
              })
            ],
            1
          ),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "text-align": "left" } },
              [
                _c("span", { staticClass: "blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_CurrentSelection")) + ":"
                  )
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      height: "28px",
                      "overflow-y": "auto",
                      "text-align": "left",
                      "word-break": "break-word",
                      "margin-left": "5px"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.displayName ? _vm.displayName : _vm.eventName
                        ) +
                        " "
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                ),
                _c("el-button", { on: { click: _vm.onReset } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))
                ]),
                _c("el-button", { on: { click: _vm.handleClose } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
                ])
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }